export default "__VITE_ASSET__cf5c74e3__"